module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/banner-b5f7bcbcb669975c2a6d59acc4b10912.png";